import React from 'react';
import {
  FiDatabase,
  FiSearch,
  FiCode,
  FiRefreshCw,
  FiZap,
  FiShield,
} from 'react-icons/fi';

const features = [
  {
    icon: FiDatabase,
    title: 'Complete Dataset',
    description:
      'Every postal code mapped to city, district, and province across Sri Lanka',
  },
  {
    icon: FiSearch,
    title: 'Fuzzy Search',
    description:
      'Smart matching handles typos, spacing issues, and partial queries with scored results',
  },
  {
    icon: FiCode,
    title: 'JSON-First',
    description:
      'Direct integration with APIs, CLIs, and any JavaScript/TypeScript project',
  },
  {
    icon: FiRefreshCw,
    title: 'Easy Normalization',
    description:
      'Handle messy user input \u2014 transform inconsistent names to canonical form',
  },
  {
    icon: FiZap,
    title: 'Lightweight & Fast',
    description:
      'Zero dependencies. Single npm install. Instant results on every query',
  },
  {
    icon: FiShield,
    title: 'TypeScript Support',
    description:
      'Full type safety with exported interfaces for PostalRecord and CitySearchResult',
  },
];

function Features() {
  return (
    <section id="features" className="py-20 sm:py-28 bg-white/[0.02] overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section heading */}
        <div className="section-intro text-center mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold font-heading text-white">
            Why{' '}
            <span className="gradient-text">sl-address</span>?
          </h2>
          <p className="mt-4 text-lg text-slate-400 max-w-2xl mx-auto">
            Everything you need to work with Sri Lankan address data, packed
            into one lightweight package.
          </p>
        </div>

        {/* Feature cards horizontal track */}
        <div className="features-track flex gap-6 sm:gap-8">
          {features.map(({ icon: Icon, title, description }) => (
            <div
              key={title}
              className="feature-card group bg-white/[0.04] rounded-2xl p-8 border border-white/[0.08]
                         transition-all duration-300
                         hover:scale-[1.03] hover:bg-white/[0.07]
                         relative overflow-hidden
                         w-[280px] sm:w-[340px] flex-shrink-0"
            >
              {/* Gradient top border on hover */}
              <div
                className="absolute top-0 left-0 w-full h-1 opacity-0 group-hover:opacity-100
                           bg-gradient-to-r from-primary-500 to-accent-500
                           transition-opacity duration-300"
              />

              {/* Icon */}
              <div className="w-14 h-14 rounded-full bg-primary-500/15 flex items-center justify-center mb-6">
                <Icon className="w-6 h-6 text-primary-400" />
              </div>

              {/* Title */}
              <h3 className="text-xl font-semibold font-heading text-white mb-3">
                {title}
              </h3>

              {/* Description */}
              <p className="text-slate-400 leading-relaxed">{description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Features;
